import React from 'react';
import {
  AutoPayHelpDetailsWrapper,
  Body,
  Title,
} from './AutopayHelpDetails.styles';

const AutopayHelpDetails = () => {
  const title = 'Autopay Help';
  const body = () => (
    <>
      Want to <strong>edit</strong> your Autopay settings instead of turning it
      off completely? You must first cancel your current settings, at which
      point all scheduled automatic payments will be cancelled. After that, you
      can set up your Autopay again.
    </>
  );

  return (
    <AutoPayHelpDetailsWrapper>
      <Title>{title}</Title>
      <Body>{body()}</Body>
    </AutoPayHelpDetailsWrapper>
  );
};
export default AutopayHelpDetails;
